<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p><span class="breadcrumb-item" @click="irInicio">Inicio</span> > Publicidad</p>
    </div>
  </div>
  
  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="titulo"><h5 class="mx-4 mt-5 mb-5">Listado de campañas de publicidad</h5></div>
          <div class="table-search">
            <input id="textoBuscador" type="text" class="form-control" placeholder="Búsqueda rápida..." aria-label="Búsqueda rápida" @input="teclearBuscador" />
          </div>
          <div class="descarga doble">
            <p @click="fetchAndSetCampana" title="Refrescar datos"><i class="fa fa-sync-alt" :class="{ 'fa-spin': loadingCampanas }" aria-hidden="true"></i></p>
            <p @click="descargarCSV"><i class="fa fa-download" aria-hidden="true"></i></p>
            <p @click="abrirAltaCampana"><i class="fa fa-plus" aria-hidden="true"></i></p>
            <p @click="toggleSelectorColumnas" title="Columnas visibles" :class="{ 'activo': selectorColumnasAbierto }"><i class="fas fa-columns" aria-hidden="true"></i></p>
          </div>

          <!-- Selector de columnas -->
          <div v-if="selectorColumnasAbierto" class="selector-columnas-panel" v-click-outside="cerrarSelectorColumnas">
            <div class="selector-columnas-header">
              <span>Columnas visibles</span>
              <button class="selector-reset" @click="resetColumnas" title="Restablecer">Restablecer</button>
            </div>
            <div class="selector-columnas-grid">
              <label v-for="col in columnasConfig" :key="col.key" class="selector-col-item" :class="{ disabled: col.fija }">
                <input type="checkbox" v-model="columnasVisibles[col.key]" :disabled="col.fija" @change="guardarColumnasStorage" />
                <span class="selector-col-dot" :style="{ background: col.color }"></span>
                <span>{{ col.label }}</span>
              </label>
            </div>
          </div>
          <div class="borrados">
            <QToggle v-model="mostrarBorrados" @change="cambiarBorrados" />
            <span class="borrados-label">{{ mostrarBorrados ? 'Con eliminados' : 'Sin eliminados' }}</span>
          </div>
          <div class="filtros-admin" v-if="[1,2,5].includes(Number(miRol))">
            <select v-if="Number(miRol) === 1" v-model="filtroPublicistaId" class="form-control form-control-sm" @change="cambiarFiltroPublicista">
              <option value="">Todos los publicistas</option>
              <option v-for="p in listaPublicistas" :key="p.id" :value="p.id">{{ p.name }}</option>
            </select>
            <select v-model="filtroTipsterId" class="form-control form-control-sm">
              <option value="">Todos los tipsters</option>
              <option v-for="t in listaTipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
            </select>
            <select v-model="filtroEstado" class="form-control form-control-sm">
              <option value="">Todos los estados</option>
              <option value="P">Activa</option>
              <option value="I">Iniciada</option>
            </select>
            <button class="btn-filtrar" @click="aplicarFiltros">
              <i class="fa fa-filter me-1"></i> Filtrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-listado mt-4">
          <div class="px-4 pb-0 card-body">
            <!-- Leyenda de columnas -->
            <div class="leyenda-columnas d-none d-md-flex mb-3">
              <div class="leyenda-item"><span class="leyenda-dot dot-total"></span><strong>Total canal</strong> — miembros actuales del canal según Telegram</div>
              <div class="leyenda-item"><span class="leyenda-dot dot-entradas"></span><strong>Entradas</strong> — total histórico que alguna vez entraron al canal por esta campaña</div>
              <div class="leyenda-item"><span class="leyenda-dot dot-suscripc"></span><strong>Suscripc.</strong> — actualmente dentro del canal unidos por esta campaña</div>
              <div class="leyenda-item"><span class="leyenda-dot dot-solicitudes"></span><strong>Solicitudes</strong> — pidieron unirse, pendientes de aprobación del tipster</div>
              <div class="leyenda-item"><span class="leyenda-dot dot-rechazados"></span><strong>Rechazados</strong> — solicitudes que Telegram confirmó como no aprobadas</div>
              <div class="leyenda-item"><span class="leyenda-dot dot-salidas"></span><strong>Salidas</strong> — salieron del canal tras haber entrado</div>
              <div class="leyenda-item"><span class="leyenda-dot dot-reingresos"></span><strong>Reingresos</strong> — veces que un usuario salió y volvió a entrar</div>
              <div class="leyenda-item"><span class="leyenda-dot dot-pagos"></span><strong>V.Únicas</strong> — compras puntuales (sin suscripción) atribuidas a esta campaña</div>
              <div class="leyenda-item"><span class="leyenda-dot dot-suscs"></span><strong>Suscs.</strong> — suscripciones con primer pago real recibido atribuidas a esta campaña</div>
            </div>

            <div class="table-responsive mb-4">
              <table id="campanas-list" class="table table-flush table-listado">
                <thead class="thead-light">
                  <tr>
                    <th @click="sortTable('0')" :class="sortColumn=='0' ? sortDirection : ''">Nombre</th>
                    <th @click="sortTable('1')" :class="[sortColumn=='1' ? sortDirection : '', { 'd-none': !columnasVisibles.canal }]">Canal</th>
                    <th @click="sortTable('10')" :class="[sortColumn=='10' ? sortDirection : '', { 'd-none': !columnasVisibles.enlace }]">Enlace</th>
                    <th :class="['text-center', { 'd-none': !columnasVisibles.total_canal }]">Total canal</th>
                    <th @click="sortTable('3')" :class="[sortColumn=='3' ? sortDirection : '', { 'd-none': !columnasVisibles.entradas }]">Entradas</th>
                    <th @click="sortTable('2')" :class="[sortColumn=='2' ? sortDirection : '', { 'd-none': !columnasVisibles.suscripciones }]">Suscripc.</th>
                    <th :class="{ 'd-none': !columnasVisibles.solicitudes }">Solicitudes</th>
                    <th :class="{ 'd-none': !columnasVisibles.rechazados }">Rechazados</th>
                    <th @click="sortTable('4')" :class="[sortColumn=='4' ? sortDirection : '', { 'd-none': !columnasVisibles.salidas }]">Salidas</th>
                    <th @click="sortTable('11')" :class="[sortColumn=='11' ? sortDirection : '', { 'd-none': !columnasVisibles.reingresos }]">Reingresos</th>
                    <th @click="sortTable('5')" :class="[sortColumn=='5' ? sortDirection : '', { 'd-none': !columnasVisibles.num_pagos }]">V.Únicas</th>
                    <th @click="sortTable('6')" :class="[sortColumn=='6' ? sortDirection : '', { 'd-none': !columnasVisibles.imp_pagos }]">Suscs.</th>
                    <th
                      v-if="[1,2,5].includes(Number(miRol))"
                      @click="sortTable('7')"
                      :class="[sortColumn=='7' ? sortDirection : '', { 'd-none': !columnasVisibles.tipster }]"
                    >Tipster</th>
                    <th @click="sortTable('8')" :class="[sortColumn=='8' ? sortDirection : '', { 'd-none': !columnasVisibles.creado }]" data-type="date" data-format="DD/MM/YYYY">Creado</th>
                    <th v-if="mostrarBorrados" @click="sortTable('9')" :class="[sortColumn=='9' ? sortDirection : '', { 'd-none': !columnasVisibles.eliminado }]">Eliminado</th>
                    <th data-type="html" data-sortable="false" class="sin-orden">Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <!-- Ciclo a través de los elementos filtrados y paginados -->
                  <tr v-for="row in filas" :key="row.id">
                    <td>{{ row.nombre }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.canal }">{{ row.nomcanal }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.enlace }">{{ row.enlace }}</td>
                    <td :class="['text-center', { 'd-none': !columnasVisibles.total_canal }]">
                      <span v-if="row.total_participantes !== null" class="total-canal-badge">{{ row.total_participantes }}</span>
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td :class="{ 'd-none': !columnasVisibles.entradas }"><span class="stat-cell" @click.stop="abrirDetalle(row.id, 'entradas')">{{ row.entradas }}<i class="fas fa-eye ms-1"></i></span></td>
                    <td :class="{ 'd-none': !columnasVisibles.suscripciones }"><span class="stat-cell" @click.stop="abrirDetalle(row.id, 'suscripciones')">{{ row.suscripciones }}<i class="fas fa-eye ms-1"></i></span></td>
                    <td :class="{ 'd-none': !columnasVisibles.solicitudes }">
                      <span class="stat-cell" @click.stop="abrirDetalle(row.id, 'solicitudes')">
                        <span v-if="row.solicitudes > 0" class="badge" style="background:var(--color-warning,#f59e0b);color:#000;">{{ row.solicitudes }}</span>
                        <span v-else class="text-muted">0</span>
                        <i class="fas fa-eye ms-1"></i>
                      </span>
                    </td>
                    <td :class="{ 'd-none': !columnasVisibles.rechazados }">
                      <span class="stat-cell" @click.stop="abrirDetalle(row.id, 'rechazados')">
                        <span v-if="row.rechazados > 0" class="badge bg-danger">{{ row.rechazados }}</span>
                        <span v-else class="text-muted">0</span>
                        <i class="fas fa-eye ms-1"></i>
                      </span>
                    </td>
                    <td :class="{ 'd-none': !columnasVisibles.salidas }"><span class="stat-cell" @click.stop="abrirDetalle(row.id, 'salidas')">{{ row.salidas }}<i class="fas fa-eye ms-1"></i></span></td>
                    <td :class="{ 'd-none': !columnasVisibles.reingresos }"><span class="stat-cell" @click.stop="abrirDetalle(row.id, 'reingresos')">{{ row.reingresos }}<i class="fas fa-eye ms-1"></i></span></td>
                    <td :class="{ 'd-none': !columnasVisibles.num_pagos }">
                      <span class="stat-cell" @click.stop="abrirDetalle(row.id, 'pagos')">
                        <template v-if="row.ventas_unicas > 0">
                          <span class="fw-semibold">{{ row.ventas_unicas }}</span>
                          <span class="text-muted ms-1 small">
                            <template v-if="row.ventas_unicas_eur > 0">{{ row.ventas_unicas_eur.toFixed(2) }}€</template>
                            <template v-if="row.ventas_unicas_eur > 0 && row.ventas_unicas_usd > 0"> · </template>
                            <template v-if="row.ventas_unicas_usd > 0">{{ row.ventas_unicas_usd.toFixed(2) }}$</template>
                          </span>
                        </template>
                        <template v-else><span class="text-muted">—</span></template>
                        <i class="fas fa-eye ms-1"></i>
                      </span>
                    </td>
                    <td :class="{ 'd-none': !columnasVisibles.imp_pagos }">
                      <span class="stat-cell" @click.stop="abrirDetalle(row.id, 'pagos')">
                        <template v-if="row.suscs_pagadas > 0">
                          <span class="fw-semibold">{{ row.suscs_pagadas }}</span>
                          <span class="text-muted ms-1 small">
                            <template v-if="row.suscs_pagadas_eur > 0">{{ row.suscs_pagadas_eur.toFixed(2) }}€</template>
                            <template v-if="row.suscs_pagadas_eur > 0 && row.suscs_pagadas_usd > 0"> · </template>
                            <template v-if="row.suscs_pagadas_usd > 0">{{ row.suscs_pagadas_usd.toFixed(2) }}$</template>
                          </span>
                        </template>
                        <template v-else><span class="text-muted">—</span></template>
                        <i class="fas fa-eye ms-1"></i>
                      </span>
                    </td>
                    <td v-if="[1,2,5].includes(Number(miRol))" :class="{ 'd-none': !columnasVisibles.tipster }">{{ row.tipster_name }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.creado }">{{ row.created }}</td>
                    <td v-if="mostrarBorrados" :class="{ 'd-none': !columnasVisibles.eliminado }">{{ row.deleted }}</td>
                    <td>
                      <template v-if="!row.deleted">
                        <a href="#" class="cursor-pointer me-3" title="Editar Campaña" @click.prevent="editarCampana(row.id)">
                          <i class="fas fa-edit text-secondary"></i>
                        </a>
                        <a href="#" class="cursor-pointer me-3" title="Eliminar Campaña" @click.prevent="mostrarConfirmacionBorrar(row.id)">
                          <i class="fas fa-trash text-secondary"></i>
                        </a>
                        <a href="#" class="cursor-pointer me-3" title="Copiar enlace Telegram" @click.prevent="copiarEnlace(row.enlace)">
                          <i class="fas fa-clipboard text-secondary"></i>
                        </a>
                        <a
                          href="#"
                          class="cursor-pointer me-3"
                          title="Landings (nueva pestaña)"
                          @click.prevent="abrirLandingsNuevaPestana(row)"
                        >
                          <i class="fas fa-rocket" style="color:#00e676"></i>
                        </a>
                      </template>
                    </td>
                  </tr>
                  <tr v-if="filas.length==0">
                    <td :colspan="colspanTabla">No hay registros que mostrar</td>
                  </tr>


                </tbody>
              </table>
            </div>
            <!-- Control de la Paginacion manual -->
            <div class="paginacion" v-if="filas.length>0">
              <p class="contador-listado">Mostrando {{ mostradosIni }} a {{ mostradosFin }} de {{ mostradosTotal }} registros</p>

              <ul class="pagination pagination-md" v-if="paginaTotal>1">
                <li class="page-item prev-page" v-if="paginaActual>1">
                  <a class="page-link" aria-label="Previous" @click="paginaActual=paginaActual-1;fetchAndSetCampana();">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                  </a>
                </li>
                <li v-for="index in rangoPaginas" :key="index" class="page-item" :class="index==paginaActual ? 'active disabled' : ''">
                  <a class="page-link" @click="paginaActual=index;fetchAndSetCampana();">{{index}}</a>
                </li>
                <li class="page-item next-page" v-if="paginaActual<paginaTotal">
                  <a class="page-link" aria-label="Next" @click="paginaActual=paginaActual+1;fetchAndSetCampana();">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Modal @cerrar-modal="cerrarModal" :modalActive="modalActive">
    
    <alta-campana-form
      v-if="tipoModal=='A'"
      @cerrar-modal="() => { this.modalActive=false; this.tipoModal=''; fetchAndSetCampana(); }"
      @campana-creada="onCampanaCreada"
      :key="modalKey"
      :campanaBotName="botName"
    />

    <edita-campana-form
      v-if="tipoModal=='E'"
      @cerrar-modal="() => { this.modalActive=false;fetchAndSetCampana();}"
      :key="campanaEditId"
      :campanaId="campanaEditId"
      :campanaEstado="campanaEditEstado"
      :campanaNombre="campanaEditNombre"
      :campanaUuid="campanaEditUuid"
    />
  </Modal>


  <!-- Modal detalle campaña -->
  <div v-if="detalle.visible" class="overlay" @click.self="detalle.visible=false">
    <div class="detalle-box" :class="'detalle-tipo-' + detalle.tipo">

      <!-- Header -->
      <div class="detalle-header">
        <div class="detalle-header-left">
          <span class="detalle-tipo-dot"></span>
          <div>
            <div class="detalle-titulo">{{ detalle.titulo }}</div>
            <div v-if="!detalle.loading" class="detalle-subtitulo">
              {{ detalle.filas.length }} {{ detalle.filas.length === 1 ? 'registro' : 'registros' }}
            </div>
          </div>
        </div>
        <div class="detalle-header-actions">
          <button
            v-if="detalle.tipo === 'suscripciones'"
            class="btn-actualizar-nicks"
            :disabled="actualizandoNicks || detalle.loading"
            @click="actualizarNicks"
            title="Consulta la API de Telegram y actualiza nick y nombre de cada suscriptor"
          >
            <i v-if="actualizandoNicks" class="fas fa-spinner fa-spin"></i>
            <i v-else class="fab fa-telegram"></i>
            {{ actualizandoNicks ? 'Actualizando...' : 'Actualizar nick Telegram' }}
          </button>
          <button class="detalle-cerrar" @click="detalle.visible=false">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <!-- Body -->
      <div class="detalle-body">

        <!-- Loading -->
        <div v-if="detalle.loading" class="detalle-loading">
          <div class="detalle-spinner"></div>
          <span>Cargando...</span>
        </div>

        <!-- Vacío -->
        <div v-else-if="detalle.filas.length === 0" class="detalle-empty">
          <i class="fas fa-inbox detalle-empty-icon"></i>
          <p>Sin registros para esta campaña</p>
        </div>

        <!-- Tabla -->
        <div v-else class="table-responsive">
          <table class="table table-sm table-flush detalle-tabla">
            <thead>
              <tr>
                <th v-for="col in detalle.cols" :key="col.key">{{ col.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(fila, i) in detalle.filas" :key="i">
                <td v-for="col in detalle.cols" :key="col.key">
                  <template v-if="col.key === 'telegram_username'">
                    <span v-if="fila[col.key]" class="detalle-username">@{{ fila[col.key] }}</span>
                    <span v-else class="text-muted">—</span>
                  </template>
                  <template v-else-if="col.key === 'idioma'">
                    <span v-if="fila[col.key]" class="detalle-badge-idioma">{{ fila[col.key].toUpperCase() }}</span>
                    <span v-else class="text-muted">—</span>
                  </template>
                  <template v-else-if="col.tipo === 'fecha'">{{ fila[col.key] ? formatDate(fila[col.key], 'DD/MM/YYYY HH:mm') : '—' }}</template>
                  <template v-else-if="col.tipo === 'euro'">
                    <span class="detalle-euro">{{ fila[col.key] != null ? Number(fila[col.key]).toFixed(2) + '€' : '—' }}</span>
                  </template>
                  <template v-else-if="col.tipo === 'importe'">
                    <span :class="fila.moneda === 'USD' ? 'detalle-usd' : 'detalle-euro'">
                      {{ fila[col.key] != null ? Number(fila[col.key]).toFixed(2) + (fila.moneda === 'USD' ? '$' : '€') : '—' }}
                    </span>
                  </template>
                  <template v-else>{{ fila[col.key] ?? '—' }}</template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>

  <div v-if="confirmacionVisible" class="overlay">
    <div class="confirm-box">
      <p class="mt-4 mb-4">{{ mensajeConfirmacion }}</p>
      <table class="mt-4 mb-4"><tr>
        <td width="50%"><QBtn variant="cancela" label="Cancelar" @click="cancelacion" /></td>
        <td width="50%"><QBtn variant="confirma" label="Confirmar" @click="confirmacion" /></td>
      </tr></table>
    </div>
  </div>
</template>

<script>
import api from '@/services/apiClient';
import showSwal from "@/mixins/showSwal.js";
import Modal from './components/Modal.vue';
import AltaCampanaForm from './components/AltaCampanaForm.vue';
import EditaCampanaForm from './components/EditaCampanaForm.vue';
import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';

const STORAGE_KEY_COLUMNAS = 'campanas_columnas_v1';

const COLUMNAS_DEFAULT = {
  canal: true, enlace: false, total_canal: true,
  entradas: true, suscripciones: true, solicitudes: true,
  rechazados: true, salidas: true, reingresos: true,
  num_pagos: true, imp_pagos: true, tipster: true,
  creado: true, eliminado: true,
};

const COLUMNAS_MOBILE = {
  canal: false, enlace: false, total_canal: true,
  entradas: false, suscripciones: true, solicitudes: true,
  rechazados: false, salidas: false, reingresos: false,
  num_pagos: false, imp_pagos: false, tipster: false,
  creado: false, eliminado: false,
};

export default {
  name: "Campanas",
  components: {
    Modal,
    AltaCampanaForm,
    EditaCampanaForm,
  },
  directives: {
    clickOutside: {
      beforeMount(el, binding) {
        el._clickOutsideHandler = (e) => { if (!el.contains(e.target)) binding.value(e); };
        setTimeout(() => document.addEventListener('click', el._clickOutsideHandler), 0);
      },
      unmounted(el) { document.removeEventListener('click', el._clickOutsideHandler); },
    },
  },
  mixins: [globalFunctionsMixin],
  data() {
    return {
      modalKey: 0,
      filas: [],
      filasBoton: [],
      confirmacionVisible: false,
      campanaId: 0,
      mensajeConfirmacion: '',
      tipoModal: '',
      campanaEditId: 0,
      campanaEditNombre: '',
      campanaEditEstado: '',
      campanaEditUuid: '',
      textoBuscador: '',
      paginaActual: 0,
      paginaTotal: 0,
      mostrarBorrados: false,
      mostradosIni: 0,
      mostradosFin: 0,
      mostradosTotal: 0,
      sortColumn: 0,
      sortDirection: '',
      modalActive: false,
      botName: '',
      searchTimeout: null,
      listenersBound: false,
      listaPublicistas: [],
      listaTipsters: [],
      listaTipsterosFiltrados: [],
      filtroTipsterId: '',
      filtroPublicistaId: '',
      filtroEstado: '',
      detalle: { visible: false, loading: false, tipo: '', titulo: '', filas: [], cols: [], campanaId: null },
      actualizandoNicks: false,
      loadingCampanas: false,
      selectorColumnasAbierto: false,
      columnasVisibles: { ...COLUMNAS_DEFAULT },
    };
  },
  computed: {
    miRol() { return this.$store.getters["auth/rolEfectivo"]; },
    columnasConfig() {
      const cols = [
        { key: 'canal',        label: 'Canal',       color: '#6b7280' },
        { key: 'enlace',       label: 'Enlace',      color: '#6b7280' },
        { key: 'total_canal',  label: 'Total canal', color: '#8b5cf6' },
        { key: 'entradas',     label: 'Entradas',    color: '#3b82f6' },
        { key: 'suscripciones',label: 'Suscripc.',   color: '#10b981' },
        { key: 'solicitudes',  label: 'Solicitudes', color: '#f59e0b' },
        { key: 'rechazados',   label: 'Rechazados',  color: '#ef4444' },
        { key: 'salidas',      label: 'Salidas',     color: '#6b7280' },
        { key: 'reingresos',   label: 'Reingresos',  color: '#8b5cf6' },
        { key: 'num_pagos',    label: 'V. Únicas',   color: '#00e676' },
        { key: 'imp_pagos',    label: 'Suscs.',      color: '#26c6da' },
        { key: 'creado',       label: 'Creado',      color: '#6b7280' },
      ];
      if ([1,2,5].includes(Number(this.miRol))) {
        cols.splice(11, 0, { key: 'tipster', label: 'Tipster', color: '#6b7280' });
      }
      if (this.mostrarBorrados) {
        cols.push({ key: 'eliminado', label: 'Eliminado', color: '#ef4444' });
      }
      return cols;
    },
    rangoPaginas() {
      let startPage = Math.max(this.paginaActual - 3, 1);
      let endPage = Math.min(this.paginaActual + 3,this.paginaTotal);
      let pages = [];
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    },
    colspanTabla() {
      const verTipster = [1,2,5].includes(Number(this.miRol));
      const verEliminado = !!this.mostrarBorrados;

      // columnas fijas:
      // Nombre, Canal, Enlace, Suscripc, Entradas, Salidas, Reingresos, Núm.pagos, Imp.pagos, Creado, Acciones = 11
      let total = 11;

      if (verTipster) total += 1;
      if (verEliminado) total += 1;

      return total;
    }
  },
  methods: {
    toggleSelectorColumnas() {
      this.selectorColumnasAbierto = !this.selectorColumnasAbierto;
    },
    cerrarSelectorColumnas() {
      this.selectorColumnasAbierto = false;
    },
    guardarColumnasStorage() {
      try { localStorage.setItem(STORAGE_KEY_COLUMNAS, JSON.stringify(this.columnasVisibles)); } catch (e) { /* storage no disponible */ }
    },
    resetColumnas() {
      const esMobile = window.innerWidth < 768;
      this.columnasVisibles = { ...(esMobile ? COLUMNAS_MOBILE : COLUMNAS_DEFAULT) };
      this.guardarColumnasStorage();
    },
    cargarColumnasStorage() {
      try {
        const guardado = localStorage.getItem(STORAGE_KEY_COLUMNAS);
        if (guardado) {
          this.columnasVisibles = { ...COLUMNAS_DEFAULT, ...JSON.parse(guardado) };
        } else {
          this.columnasVisibles = { ...(window.innerWidth < 768 ? COLUMNAS_MOBILE : COLUMNAS_DEFAULT) };
        }
      } catch {
        this.columnasVisibles = { ...COLUMNAS_DEFAULT };
      }
    },

    alert() {
      showSwal.methods.showSwal({
        type: "error",
        message: "This is a PRO feature.",
        width: 400,
      });
    },

    async descargarCSV() {
      try {
        const response = await this.$store.dispatch("auth/exportarCampanas");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "campanas_" + new Date().toISOString().slice(0, 10) + ".xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        showSwal.methods.showSwal({ type: "error", message: "No se pudo generar el archivo.", width: 400 });
      }
    },

    async initializeDataTable() {

      this.sortColumn=8;
      this.sortDirection='desc';
      this.textoBuscador = '';
      this.paginaActual = 1;
      await this.fetchAndSetCampana();

    },

    sortTable(key) {
      // Alternar entre ascendente y descendente al hacer clic en el encabezado
      if (this.sortColumn === key) {
        this.sortDirection = this.sortDirection=='asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = key;
        this.sortDirection = 'asc';
      }
      this.fetchAndSetCampana();
    },

    teclearBuscador(event) {
      this.textoBuscador = event.target.value;

      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.paginaActual = 1;
        this.fetchAndSetCampana();
      }, 500);
    },


    async fetchAndSetCampana() {
      this.loadingCampanas = true;
      try {
        // Petición al servidor
        const response = await this.$store.dispatch("auth/campanas", {
          textoBuscador: this.textoBuscador,
          paginaActual: this.paginaActual,
          mostrarBorrados: this.mostrarBorrados,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection,
          tipster_id: this.filtroTipsterId || null,
          publicista_id: this.filtroPublicistaId || null,
          estado: this.filtroEstado || null,
        });
        
        // Procesar los datos y actualizarlos en el DataTable
        this.filas = response.data.map(row => ({
          id: row.id,
          nombre: row.nombre,
          nomcanal: row.canal_name,
          enlace: row.enlace,
          total_participantes: row.total_participantes ?? null,
          suscripciones: row.suscripciones,
          entradas: row.entradas,
          solicitudes: row.solicitudes ?? 0,
          rechazados: row.rechazados ?? 0,
          salidas: row.salidas,
          reingresos: row.reingresos ?? 0,
          numero_pagos: row.numero_pagos,
          importe_pagos_eur: row.importe_pagos_eur,
          importe_pagos_usd: row.importe_pagos_usd,
          ventas_unicas: row.ventas_unicas ?? 0,
          ventas_unicas_eur: row.ventas_unicas_eur ?? 0,
          ventas_unicas_usd: row.ventas_unicas_usd ?? 0,
          suscs_pagadas: row.suscs_pagadas ?? 0,
          suscs_pagadas_eur: row.suscs_pagadas_eur ?? 0,
          suscs_pagadas_usd: row.suscs_pagadas_usd ?? 0,
          tipster_name: row.tipster_name,
          landing_slug: row.landing_slug || null,
          landing_id:   row.landing_id   || null,
          created: this.formatDate(row.created_at, 'DD/MM/YYYY'),
          deleted: row.deleted_at ? this.formatDate(row.deleted_at, 'DD/MM/YYYY') : '',
        }));
        this.filasBoton = response.data.map(row => ({
          id: row.id,
          nombre: row.nombre,
          uuid: row.uuid,
          estado: row.estado,
        }));

        this.paginaTotal = response.paginas;
        this.mostradosIni = (response.actual-1)*response.porpagina + 1;
        this.mostradosFin = Math.min(response.totales,response.actual*response.porpagina);
        this.mostradosTotal = response.totales;
        this.botName = response.botname;

      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.loadingCampanas = false;
      }
    },

    mostrarConfirmacionBorrar(id) {
      this.confirmacionVisible = true;
      this.campanaId = id;
      this.mensajeConfirmacion = '¿Confirma que desea eliminar esta campaña?';
    },
    confirmacion() {
      this.confirmacionVisible = false;
      this.borrarCampana(this.campanaId);
    },
    cancelacion() {
      this.confirmacionVisible = false;
    },
    async abrirAltaCampana() {
      this.tipoModal = 'A';
      this.modalKey++; 
      this.modalActive = true; 
    },
    cerrarModal() {
      this.modalActive = false;
      this.tipoModal = '';
    },
    onCampanaCreada() {
      this.modalActive = false;
      this.tipoModal = '';
      this.fetchAndSetCampana();
    },
    async cambiarBorrados() {
      await this.initializeDataTable();
    },
    async borrarCampana(campanaId) {
      try {
        const resp = await this.$store.dispatch("auth/borraCampana",{id: campanaId});
        if (resp.res=='OK') {
            showSwal.methods.showSwal({
                type: "success",
                message: resp.mensaje,
                width: 600,
            });
            this.fetchAndSetCampana();
            this.$emit('cerrar-modal');
        }
        else {
            showSwal.methods.showSwal({
                type: "error",
                message: resp.mensaje,
                width: 500
            });               
        }
      } 
      catch (error) {
        showSwal.methods.showSwal({
            type: "error",
            message: "Se ha producido un error",
            width: 500,
        });
      }
    },
    editarCampana(id) {
      const row = this.filasBoton.find(r => String(r.id) === String(id));
      if (!row) return;
      this.modalActive = true;
      this.tipoModal = 'E';
      this.campanaEditNombre = row.nombre;
      this.campanaEditEstado = row.estado;
      this.campanaEditUuid = row.uuid;
      this.campanaEditId = row.id;
    },
    copiarEnlace(enlace) {
      navigator.clipboard.writeText(enlace).then(() => {
        showSwal.methods.showSwal({
          type: "success",
          message: 'Enlace copiado al portapapeles',
          width: 600,
        });
      });
    },
    async abrirDetalle(campanaId, tipo) {
      const titulos = {
        suscripciones: 'Suscriptores activos',
        entradas:      'Entradas',
        solicitudes:   'Solicitudes pendientes',
        rechazados:    'Solicitudes rechazadas',
        salidas:       'Salidas',
        reingresos:    'Reingresos',
        pagos:         'Pagos',
      };
      const colsMap = {
        suscripciones: [
          { key: 'telegram_id', label: 'ID Telegram' },
          { key: 'nombre', label: 'Nombre' },
          { key: 'telegram_username', label: 'Nick Telegram' },
          { key: 'fecha', label: 'Última entrada', tipo: 'fecha' },
          { key: 'reingresos', label: 'Reingresos' },
        ],
        entradas: [
          { key: 'telegram_id', label: 'ID Telegram' },
          { key: 'nombre', label: 'Nombre' },
          { key: 'telegram_username', label: 'Nick Telegram' },
          { key: 'fecha_entrada', label: 'Fecha entrada', tipo: 'fecha' },
          { key: 'fecha_salida', label: 'Fecha salida', tipo: 'fecha' },
          { key: 'reingresos', label: 'Reingresos' },
        ],
        solicitudes: [
          { key: 'telegram_id', label: 'ID Telegram' },
          { key: 'nombre', label: 'Nombre' },
          { key: 'telegram_username', label: 'Nick Telegram' },
          { key: 'idioma', label: 'Idioma' },
          { key: 'fecha', label: 'Fecha solicitud', tipo: 'fecha' },
        ],
        rechazados: [
          { key: 'telegram_id', label: 'ID Telegram' },
          { key: 'nombre', label: 'Nombre' },
          { key: 'telegram_username', label: 'Nick Telegram' },
          { key: 'idioma', label: 'Idioma' },
          { key: 'fecha_solicitud', label: 'Fecha solicitud', tipo: 'fecha' },
          { key: 'fecha_rechazo', label: 'Fecha rechazo', tipo: 'fecha' },
        ],
        salidas: [
          { key: 'telegram_id', label: 'ID Telegram' },
          { key: 'nombre', label: 'Nombre' },
          { key: 'telegram_username', label: 'Nick Telegram' },
          { key: 'fecha_entrada', label: 'Fecha entrada', tipo: 'fecha' },
          { key: 'fecha_salida', label: 'Fecha salida', tipo: 'fecha' },
        ],
        reingresos: [
          { key: 'telegram_id', label: 'ID Telegram' },
          { key: 'nombre', label: 'Nombre' },
          { key: 'telegram_username', label: 'Nick Telegram' },
          { key: 'reingresos', label: 'Núm. reingresos' },
          { key: 'ultima_entrada', label: 'Última entrada', tipo: 'fecha' },
        ],
        pagos: [
          { key: 'telegram_id', label: 'ID Telegram' },
          { key: 'nombre', label: 'Nombre' },
          { key: 'telegram_username', label: 'Nick Telegram' },
          { key: 'email', label: 'Email' },
          { key: 'nombre_producto', label: 'Servicio' },
          { key: 'precio', label: 'Importe', tipo: 'importe' },
          { key: 'fecha', label: 'Fecha', tipo: 'fecha' },
        ],
      };
      this.detalle = { visible: true, loading: true, tipo, titulo: titulos[tipo] || tipo, filas: [], cols: colsMap[tipo] || [], campanaId };
      try {
        const resp = await this.$store.dispatch('auth/campanaDetalle', { campana_id: campanaId, tipo });
        this.detalle.filas = resp.data || [];
      } catch (e) {
        this.detalle.filas = [];
      } finally {
        this.detalle.loading = false;
      }
    },

    async actualizarNicks() {
      if (!this.detalle.campanaId || this.actualizandoNicks) return;
      this.actualizandoNicks = true;
      try {
        const resp = await this.$store.dispatch('auth/campanaActualizarNicks', this.detalle.campanaId);
        if (resp?.ok) {
          this.$swal?.fire({
            icon: 'success',
            title: 'Nicks actualizados',
            text: `Verificados: ${resp.verificados} · Actualizados: ${resp.actualizados}`,
            timer: 3000,
            showConfirmButton: false,
          });
          // Refresca los datos del modal
          const resp2 = await this.$store.dispatch('auth/campanaDetalle', { campana_id: this.detalle.campanaId, tipo: 'suscripciones' });
          this.detalle.filas = resp2.data || [];
        }
      } catch (e) {
        // silencioso
      } finally {
        this.actualizandoNicks = false;
      }
    },

    irInicio() {
      this.$router.push('/dashboard');
    },
    abrirLandingsNuevaPestana(row) {
      const resolved = this.$router.resolve({
        path: '/landings',
        query: { campana_id: row.id, nombre: row.nombre, enlace: row.enlace, canal: row.nomcanal },
      });
      window.open(resolved.href, '_blank');
    },
    async cambiarFiltroTipster() {
      this.paginaActual = 1;
      await this.fetchAndSetCampana();
    },
    async cambiarFiltroEstado() {
      this.paginaActual = 1;
      await this.fetchAndSetCampana();
    },
    async aplicarFiltros() {
      this.paginaActual = 1;
      await this.fetchAndSetCampana();
    },
    async cambiarFiltroPublicista() {
      this.filtroTipsterId = '';
      this.listaTipsterosFiltrados = [];
      if (this.filtroPublicistaId) {
        const resp = await this.$store.dispatch("auth/publicistaTipsters", {
          user_id: Number(this.filtroPublicistaId),
        });
        const asignadosSet = new Set((resp.asignados || []).map(Number));
        this.listaTipsterosFiltrados = (resp.tipsters || []).filter(t => asignadosSet.has(Number(t.id)));
      }
      this.paginaActual = 1;
      await this.fetchAndSetCampana();
    },
  },

  watch: {
    miRol: {
      immediate: true,
      async handler(val) {
        const rol = Number(val);
        if (![1, 2, 5].includes(rol) || this.listaTipsters.length > 0) return;
        const promises = [api.post('/api/v2/tipster/listar', {})];
        if (rol === 1) promises.push(this.$store.dispatch("auth/publicistas"));
        const [tipsterResp, publicistasResp] = await Promise.all(promises);
        this.listaTipsters = tipsterResp?.data?.tipsters || [];
        if (publicistasResp) this.listaPublicistas = publicistasResp?.data || [];
      },
    },
  },

  async mounted() {
    this.$store.commit('setShowFooter', true);
    this.cargarColumnasStorage();
    this.initializeDataTable();
  },

};
</script>

<style scoped>
.descarga p.activo i { color: var(--q-gold, #ffd700); }

.selector-columnas-panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 1rem;
  z-index: 999;
  background: var(--q-card, #1a1f2b);
  border: 1px solid var(--q-border, rgba(255,255,255,.1));
  border-radius: 12px;
  padding: 0;
  min-width: 280px;
  box-shadow: 0 12px 40px rgba(0,0,0,.4);
  overflow: hidden;
}
.selector-columnas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.65rem 1rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: var(--q-muted, #888);
  border-bottom: 1px solid var(--q-border, rgba(255,255,255,.08));
  background: var(--q-hover, rgba(255,255,255,.04));
}
.selector-reset {
  font-size: 0.72rem;
  color: var(--q-gold, #ffd700);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  opacity: .75;
  transition: opacity .15s;
}
.selector-reset:hover { opacity: 1; }
.selector-columnas-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px;
  padding: 0.5rem;
}
.selector-col-item {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background .12s;
  user-select: none;
}
.selector-col-item:hover { background: var(--q-hover, rgba(255,255,255,.06)); }
.selector-col-item input[type="checkbox"] { margin: 0; cursor: pointer; accent-color: var(--q-gold, #ffd700); }
.selector-col-dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ficha-buscador necesita position:relative para que el panel se posicione bien */
.ficha-buscador { position: relative; }

.borrados {
  display: flex;
  align-items: center;
  gap: 8px;
}
.borrados-label {
  font-size: 0.78rem;
  color: var(--q-muted);
  white-space: nowrap;
}
.filtros-admin {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 1rem;
  flex-wrap: wrap;
}
.filtros-admin select {
  min-width: 0;
  width: 100%;
  max-width: 220px;
  font-size: 0.82rem;
}
.btn-filtrar {
  font-size: 0.8rem;
  font-weight: 600;
  padding: 5px 14px;
  border-radius: 8px;
  background: var(--q-gold, #ffd700);
  color: #000;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}
.btn-filtrar:hover { opacity: .85; }
@media (max-width: 767px) {
  .filtros-admin {
    padding: 0 0.75rem 0.5rem;
  }
  .filtros-admin select {
    max-width: 100%;
    flex: 1 1 140px;
  }
}

#campanas-list td {
  vertical-align: middle;
}

.leyenda-columnas {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.25rem;
  font-size: 0.78rem;
  color: var(--q-text-muted, #888);
  padding: 0.5rem 0.25rem;
  border-left: 3px solid var(--q-primary, #00e676);
  background: var(--q-surface-alt, rgba(0,0,0,0.04));
  border-radius: 4px;
  padding-left: 0.75rem;
}
.leyenda-item { display: flex; align-items: center; gap: 0.35rem; }
.leyenda-dot {
  display: inline-block;
  width: 10px; height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
.dot-total       { background: #8b5cf6; }
.dot-entradas    { background: #3b82f6; }
.dot-suscripc    { background: #10b981; }
.dot-solicitudes { background: #f59e0b; }
.dot-rechazados  { background: #ef4444; }
.dot-salidas     { background: #6b7280; }
.dot-reingresos  { background: #8b5cf6; }
.dot-pagos       { background: #00e676; }
.dot-suscs       { background: #26c6da; }

.total-canal-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  background: rgba(139,92,246,0.15);
  color: #8b5cf6;
  font-weight: 700;
  font-size: 12px;
}
.stat-cell {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.stat-cell .fa-eye {
  font-size: 0.72rem;
  opacity: 0.45;
  transition: opacity .15s;
}
.stat-cell:hover .fa-eye { opacity: 1; color: var(--q-primary, #00e676); }

/* ── Modal detalle ── */
.detalle-box {
  background: var(--q-card-bg, #1a1f2b);
  border: 1px solid var(--q-border, rgba(255,255,255,.1));
  border-radius: 14px;
  width: min(94vw, 760px);
  max-height: 82vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0,0,0,.55);
  overflow: hidden;
}

/* Acento de color en borde superior según tipo */
.detalle-tipo-entradas    { border-top: 3px solid #3b82f6; }
.detalle-tipo-suscripciones { border-top: 3px solid #10b981; }
.detalle-tipo-solicitudes { border-top: 3px solid #f59e0b; }
.detalle-tipo-rechazados  { border-top: 3px solid #ef4444; }
.detalle-tipo-salidas     { border-top: 3px solid #6b7280; }
.detalle-tipo-reingresos  { border-top: 3px solid #8b5cf6; }
.detalle-tipo-pagos       { border-top: 3px solid #00e676; }

/* Dot de color en header */
.detalle-tipo-entradas    .detalle-tipo-dot { background: #3b82f6; }
.detalle-tipo-suscripciones .detalle-tipo-dot { background: #10b981; }
.detalle-tipo-solicitudes .detalle-tipo-dot { background: #f59e0b; }
.detalle-tipo-rechazados  .detalle-tipo-dot { background: #ef4444; }
.detalle-tipo-salidas     .detalle-tipo-dot { background: #6b7280; }
.detalle-tipo-reingresos  .detalle-tipo-dot { background: #8b5cf6; }
.detalle-tipo-pagos       .detalle-tipo-dot { background: #00e676; }

.detalle-tipo-dot {
  width: 10px; height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 3px;
}

.detalle-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--q-border, rgba(255,255,255,.08));
  background: var(--q-surface-alt, rgba(0,0,0,.15));
}
.detalle-header-left {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
}
.detalle-titulo {
  font-weight: 700;
  font-size: 0.97rem;
  line-height: 1.2;
}
.detalle-subtitulo {
  font-size: 0.75rem;
  color: var(--q-text-muted, #888);
  margin-top: 2px;
}
.detalle-header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.btn-actualizar-nicks {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.78rem;
  padding: 5px 12px;
  border-radius: 8px;
  border: 1px solid rgba(41, 182, 246, 0.4);
  background: rgba(41, 182, 246, 0.1);
  color: #29b6f6;
  cursor: pointer;
  transition: background .15s, border-color .15s;
  white-space: nowrap;
}
.btn-actualizar-nicks:hover:not(:disabled) {
  background: rgba(41, 182, 246, 0.2);
  border-color: rgba(41, 182, 246, 0.7);
}
.btn-actualizar-nicks:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.detalle-cerrar {
  background: none; border: none; cursor: pointer;
  color: var(--q-muted, #888); font-size: 1rem; padding: 4px 6px;
  border-radius: 6px; line-height: 1;
  transition: background .15s, color .15s;
}
.detalle-cerrar:hover {
  background: rgba(255,255,255,.08);
  color: var(--q-text);
}

.detalle-body {
  overflow-y: auto;
  padding: 1rem 1.25rem;
  flex: 1;
}

/* Loading */
.detalle-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 2.5rem 0;
  color: var(--q-muted, #888);
  font-size: 0.85rem;
}
.detalle-spinner {
  width: 28px; height: 28px;
  border: 3px solid rgba(255,255,255,.1);
  border-top-color: var(--q-primary, #00e676);
  border-radius: 50%;
  animation: spin .7s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* Vacío */
.detalle-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 2.5rem 0;
  color: var(--q-text-muted, #888);
}
.detalle-empty-icon {
  font-size: 2rem;
  opacity: 0.3;
}
.detalle-empty p { margin: 0; font-size: 0.85rem; }

/* Tabla */
.detalle-tabla {
  font-size: 0.75rem;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}
.detalle-tabla thead th {
  font-size: 0.67rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: var(--q-text-muted, #888);
  border-bottom: 1px solid var(--q-border, rgba(255,255,255,.08));
  padding: 0.35rem 0.6rem;
  white-space: nowrap;
}
.detalle-tabla tbody tr {
  transition: background .12s;
}
.detalle-tabla tbody tr:hover {
  background: var(--q-surface-alt, rgba(255,255,255,.04));
}
.detalle-tabla tbody td {
  padding: 0.35rem 0.6rem;
  border-bottom: 1px solid var(--q-border, rgba(255,255,255,.05));
  vertical-align: middle;
  white-space: nowrap;
}
.detalle-tabla tbody tr:last-child td { border-bottom: none; }

/* Badges inline */
.detalle-username {
  font-size: 0.78rem;
  color: var(--q-primary, #00e676);
  background: rgba(0,230,118,.08);
  border-radius: 4px;
  padding: 1px 6px;
}
.detalle-badge-idioma {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: .04em;
  background: var(--q-surface-alt, rgba(255,255,255,.08));
  border-radius: 4px;
  padding: 2px 6px;
  color: var(--q-text-muted, #aaa);
}
.detalle-euro {
  font-weight: 600;
  color: var(--q-primary, #00e676);
}
.detalle-usd {
  font-weight: 600;
  color: #26c6da;
}
</style>



